import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFieldArray, useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import { InfoBox, SummaryCard } from "../../components/StyledComponent";
import { Button, Table } from "react-bootstrap";
import InputWrapper from "../../layout/inputWrapper";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";

import { CircularProgress, IconButton, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
// import PaymentMemoTable from "../../../../employee/AllViewRemarks/PaymentChallan/PaymentMemoDetails";
import ChallanDetails from "../../../../employee/AllViewRemarks/PaymentChallan/ChallanDetails";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";

const Step3 = ({ formData, handleTabChange, isEmployee }) => {
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const { data, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  const feeDetail = formData?.taxHeadEstimates?.[0];
  const [taxHead, setTaxHead] = useState(formData?.taxHeadEstimates?.[formData?.taxHeadEstimates?.length - 1]?.paymentHeads || []);
  const [calculateTaxHead, setCalculateTaxHead] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [enableSave, setEnableSave] = useState(false);
  const paymentHeads = data?.BPA?.MapSubPaymentHeads || [];
  const payHead = { checked: false, label: "", updatedAreaJE: null, plotarea: null, plotBuildUpArea: null, rate: null };
  console.log(paymentHeads, "paymentheads");
  console.log(feeDetail, formData, "feeDeetails");

  const defaultValues = {
    ...formData,
    // paymentHeads: formData?.paymentHeads || paymentHeads || [payHead],
  };
  const { handleSubmit, control, setValue, watch, reset } = useForm({ defaultValues });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "paymentHeads",
  });

  const handleAddInput = () => {
    append(payHead);
  };
  const handleCalculate = async () => {
    setIsLoading(true);
    const paymentHeads = watch("formPaymentHeads");
    const checkedheads = paymentHeads.filter((e) => e.checked).map((item) => ({ feeType: item.label, ...item }));
    console.log({ paymentHeads, checkedheads }, "watchingPaymentHeads");
    formData.paymentHeads = checkedheads;
    const CalulationCriteria = [{ BPA: { ...formData }, tenantId: "up", feeType: "ApplicationFee" }];
    const data = await Digit.OBPSService.bpacalculate({ CalulationCriteria });
    console.log(data, "calculationData");
    const currentTaxHeads = [...data?.Calculations?.[0]?.taxHeadEstimates?.[0]?.paymentHeads] || [];
    console.log(({ currentTaxHeads }, "currentTaxHeads"));
    setTaxHead(currentTaxHeads);
    setCalculateTaxHead(data?.Calculations?.[0]?.taxHeadEstimates);
    Modal("Fee calculated successfully", `Please click on Save to update the calculated fee details.`, "success");
    setIsLoading(false);
    setEnableSave(true);
  };
  const calculateRate = (plotArea, ranges) => {
    console.log("rangesFromCalculate", ranges, plotArea);

    for (const range of ranges) {
      if (range.area.includes("-")) {
        const [min, max] = range.area.split("-").map(Number);
        if (plotArea >= min && plotArea <= max) {
          return range.rate;
        }
      } else if (range.area.endsWith("+")) {
        const base = parseInt(range.area);
        if (plotArea > base) {
          const additional = plotArea - base;
          const blocks = Math.ceil(additional / 1000);
          return (ranges.find((r) => r.area === "501-1000")?.rate || 0) + blocks * range.ratePerAdditional1000;
        }
      }
    }
    return 0; // default if no match
  };
  const totalTaxHeadAmount = taxHead?.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
  const totalFeeAmount = parseFloat(feeDetail?.mapRate?.price) || 0;
  const totalAmount = totalTaxHeadAmount + totalFeeAmount;
  const onSubmit = (data) => {
    data.paymentHeads = taxHead;
    data.taxHeadEstimates = calculateTaxHead || formData?.taxHeadEstimates;
    handleTabChange(4, data);
  };
    const Modal = useModal();

    const [disclaimerShown, setDisclaimerShown] = useState(false);

const openDisclaimerModal = () => {
  if (disclaimerShown) return;

  Modal(
    "",
    "The rates indicated in the fee calculation table are for general reference only. Please apply the applicable rates as per the concerned Development Authority..",
    "info",
    null,
    () => setDisclaimerShown(true),
    "I Understand"
  );
};

if (!disclaimerShown) {
  openDisclaimerModal();
}

  return (
    <section className="groupContainer">
        
      <form onSubmit={handleSubmit(onSubmit)}>
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Fee Details</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Plot Type:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{feeDetail?.mapRate?.name}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Total Builtup Area:</b> (SQM)
                      <br />
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{formData?.totalBuildUpArea}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Unit Price:</b> (₹)
                      <br />
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{feeDetail?.mapRate?.unitPrice}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Total Fee:</b> (₹)
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{feeDetail?.mapRate?.price}</td>
                  </tr>
                </tbody>
              </table>
              {/* <InfoBox>
                                It will be sole responsible of LTP if fee less submitted will be recovered from LTP
                            </InfoBox> */}
            </div>
          </div>
        </SummaryCard>

        {!formData?.edcrNumber && (
          <Table bordered hover responsive className="formHeaderContainer" style={{ marginTop: "20px", width: "90%" }}>
            <thead style={{ backgroundColor: "rgb(14, 55, 79)", color: "white" }}>
              <tr>
                <th style={{ width: "10%", padding: "4px" }}>Select</th>
                <th style={{ width: "30%", padding: "4px" }}>Payment Heads</th>
                <th style={{ width: "15%", padding: "3px" }}>
                  Built Up Area (SQM)
                  <br />
                </th>
                <th style={{ width: "15%", padding: "3px" }}>
                  Area by LTP
                  <br />
                </th>
                <th style={{ width: "15%", padding: "3px" }}>
                  Rate (₹)
                  <br />
                </th>
                {/* <th style={{ width: "15%", padding: "3px" }}>
                  Amount (₹)
                  <br />
                </th> */}
              </tr>
            </thead>
            <tbody>
              {paymentHeads?.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    <InputWrapper
                      type="checkbox"
                      name={`formPaymentHeads[${index}].checked`}
                      control={control}
                      containerStyles={{ padding: "0px", margin: "0" }}
                    />
                  </td>
                  {/* <td>
                    <InputWrapper
                      type="textInput"
                      name={`formPaymentHeads[${index}].feeType`}
                      control={control}
                      containerStyles={{ padding: "0px", margin: "0" }}
                       defaultValue={item?.label || item?.feeType}
                       disabled
                    />
                  </td> */}

                  <td style={{ padding: "4px 4px 4px 8px" }}>
                    <InputWrapper
                      control={control}
                      hasLabel={false}
                      placeholder="Payment head"
                      name={`formPaymentHeads[${index}].label`}
                      type="textInput"
                      mandatory
                      validation={{
                        required: { value: true, message: "Please select the payment head" },
                      }}
                      defaultValue={item?.label || ""}
                      disabled={true}
                    />
                  </td>
                  <td>
                    <InputWrapper
                      name={`formPaymentHeads[${index}].plotBuildUpArea`}
                      hasLabel={false}
                      control={control}
                      placeholder="Enter area"
                      type="textInput"
                      width="12vw"
                    />
                  </td>
                  <td>
                    <InputWrapper
                      name={`formPaymentHeads[${index}].updatedAreaJE`}
                      hasLabel={false}
                      control={control}
                      placeholder="Enter area"
                      type="textInput"
                      defaultValue={item?.buildUpArea ? formData?.totalBuildUpArea : formData?.plotArea}
                      width="12vw"
                      height={"22px"}
                      className="paymentHeadInput"
                    />
                  </td>
                  <td>
                    <InputWrapper
                      name={`formPaymentHeads[${index}].rate`}
                      hasLabel={false}
                      control={control}
                      placeholder="Enter rate"
                      type="textInput"
                      width="12vw"
                      defaultValue={item.hasOwnProperty("rate") ? item.rate : calculateRate(formData?.plotArea, item.slabs)}
                    />
                  </td>

                  {/* {taxHead?.[0]?.paymentHeads && <td>{taxHead?.[0]?.paymentHeads[index].amount}</td>} */}
                </tr>
              ))}
              {/* <div className="adornment">
                  <IconButton color="info" aria-label="Add more" onClick={() => append(payHead)}>
                    <AddIcon />
                  </IconButton>
                  {khasraArea?.length > 1 && index > 0 && (
                    <IconButton color="error" aria-label="Delete" onClick={() => remove(index)}>
                      <RemoveIcon />
                    </IconButton>
                  )}
                </div> */}
            </tbody>
          </Table>
        )}

        {!formData?.edcrNumber && (
          <Button
            variant="contained"
            color="success"
            size="medium"
            style={{
              backgroundColor: "rgb(14, 55, 79)",
              color: "white",
              borderRadius: "24px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10px",
              marginLeft: "50%",
              marginBottom: "15px",
            }}
            onClick={handleCalculate}
          >
            {isLoading ? <CircularProgress sx={{ color: "#ffffff" }} size={28} /> : "Calculate"}
          </Button>
        )}
        {!formData?.edcrNumber && (
          <React.Fragment>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="fee table">
                <TableHead>
                  <TableRow>
                    <TableCell color="white">Fee Type</TableCell>
                    <TableCell color="white" align="right">
                      Built Up Area (sqmt.)
                    </TableCell>
                    <TableCell color="white" align="right">
                      Rate (₹)
                    </TableCell>
                    <TableCell color="white" align="right">
                      Amount (₹)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {taxHead?.map((row, index) => (
                    <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row.feeType}
                      </TableCell>
                      <TableCell align="right">{row.plotBuildUpArea}</TableCell>
                      <TableCell align="right">{row.rate}</TableCell>
                      <TableCell align="right">{row.amount}</TableCell>
                    </TableRow>
                  ))}
                  <TableRow key={0} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell component="th" scope="row">
                      Building Permission Fees
                    </TableCell>
                    <TableCell align="right">{formData?.totalBuildUpArea}</TableCell>
                    <TableCell align="right">{feeDetail?.mapRate?.unitPrice}</TableCell>
                    <TableCell align="right">{feeDetail?.mapRate?.price}</TableCell>
                  </TableRow>
                  <TableRow sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
                    <TableCell colSpan={3} align="right">
                      <strong>Total Amount</strong>
                    </TableCell>
                    <TableCell align="right">
                      <strong>{totalAmount.toFixed(2)}</strong>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <ChallanDetails formData={formData} taxHead={taxHead} totalAmount={totalAmount} />
          </React.Fragment>
        )}

        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              {formData?.status !== "MAKE_PAYMENT_SELF" && (
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Prev"
                  sx={{ backgroundColor: "#CCC" }}
                  onClick={() => handleTabChange(1)}
                />
              )}
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                disabled={!enableSave}
                type="submit"
                sx={{ backgroundColor: "#157CB3" }}
              />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};
export default Step3;
